/* ==========================================================================
   SMT Drip Warehouse  —  smt-dw.js  (v2.3.1)
   Vanilla JS, no framework. Powers:
     - colour swatches that swap the card image instantly: each colour's photo
       is preloaded at the size the card shows and decoded before the swap
     - inline size tray + quick add via /cart/add.js
     - silent refresh of the cart drawer (smt-dw-cart.js) or the legacy Dawn one
     - the pack ladder: live discount-tier progress from /cart.js
     - category chips that filter the rack without a reload
   Loaded with `defer` from the rack section; guarded so duplicate tags
   (one per section) only initialise once.
   ========================================================================== */
(function () {
  'use strict';
  if (window.SMTDW) return;
  var DW = (window.SMTDW = { version: '2.3.1', afterAdd: 'stay', cartUrl: '/cart' });
  /* colour names as shown: "Black/ Neon Pink" -> "Black/Neon Pink" */
  function nice(s) { return String(s || '').replace(/\s*\/\s*/g, '/'); }

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var routes = window.routes || {};
  var ADD_URL = (routes.cart_add_url || '/cart/add') + '.js';
  var CART_URL = (routes.cart_url || '/cart') + '.js';

  /* ---------- money ------------------------------------------------------ */
  function money(cents, fmt) {
    fmt = fmt || '${{amount}}';
    var n = cents / 100;
    var two = n.toFixed(2);
    var grouped = two.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var whole = Math.round(n);
    return fmt
      .replace('{{amount}}', grouped)
      .replace('{{amount_no_decimals}}', String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace('{{amount_with_comma_separator}}', two.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace('{{amount_no_decimals_with_comma_separator}}', String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- cart -------------------------------------------------------- */
  function getCart() {
    return fetch(CART_URL, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function drawer() { return $('cart-drawer'); }
  /* Which sections /cart/add.js should bundle so the page's cart UI can be
     refreshed without a second request. The SMT drawer (smt-dw-cart.js)
     advertises its own ids; the legacy Dawn drawer is covered by the map. */
  function sectionsToRefresh() {
    var list = [];
    var d = drawer();
    if (d && typeof d.getSectionsToRender === 'function') {
      try { d.getSectionsToRender().forEach(function (s) { if (s && s.id && list.indexOf(s.id) < 0) list.push(s.id); }); } catch (e) {}
    }
    $$('[data-dw-cart][data-dw-section]').forEach(function (r) { if (list.indexOf(r.dataset.dwSection) < 0) list.push(r.dataset.dwSection); });
    if (!list.length) {
      if ($('#cart-icon-bubble')) list.push('cart-icon-bubble');
      if ($('cart-drawer #CartDrawer')) list.push('cart-drawer');
    }
    return list.join(',');
  }
  function addVariant(id) {
    var body = { id: Number(id), quantity: 1 };
    var sections = sectionsToRefresh();
    if (sections) { body.sections = sections; body.sections_url = window.location.pathname; }
    return fetch(ADD_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Could not add to bag');
        return j;
      });
    });
  }
  /* Keep the theme's cart icon and drawer in sync without opening anything. */
  function syncTheme(json) {
    if (!json || !json.sections) return;
    var d = drawer();
    if (d && d.dataset && d.dataset.dwCartDrawer === '1' && typeof d.renderContents === 'function') {
      try { d.renderContents(json, { open: false }); } catch (e) {}
      return;
    }
    var map = { 'cart-icon-bubble': '#cart-icon-bubble', 'cart-drawer': '#CartDrawer' };
    Object.keys(map).forEach(function (id) {
      var html = json.sections[id];
      var target = $(map[id]);
      if (!html || !target) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector(map[id]);
      if (fresh) target.innerHTML = fresh.innerHTML;
    });
    var inner = $('cart-drawer .drawer__inner');
    if (inner) inner.classList.remove('is-empty');
  }

  /* ---------- toast ------------------------------------------------------- */
  var toastEl, toastTimer;
  function toast(msg, linkText, href) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'dw-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = '';
    toastEl.appendChild(document.createTextNode(msg));
    if (linkText) {
      var a = document.createElement('a');
      a.href = href; a.textContent = linkText;
      toastEl.appendChild(a);
    }
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3400);
  }

  /* ---------- photos: preload, decode, then swap ------------------------- */
  /* Shopify CDN URLs carry their width as ?width=N, so one URL per colour is
     enough to rebuild the exact srcset a card was rendered with. */
  function withWidth(url, w) {
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + w);
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function widthsOf(el) {
    var out = [], re = /\s(\d+)w\s*(?:,|$)/g, m, s = (el && el.getAttribute('srcset')) || '';
    while ((m = re.exec(s))) out.push(Number(m[1]));
    return out;
  }
  function srcsetFor(url, widths) {
    return widths.map(function (w) { return withWidth(url, w) + ' ' + w + 'w'; }).join(', ');
  }
  /* Load and decode the same file the browser will pick for a card's sizes,
     so the visible image can switch to it with nothing left to wait for. */
  var warmed = {};
  function warm(url, widths, sizes, urgent) {
    var key = url + '|' + sizes;
    if (warmed[key]) return warmed[key].p;
    var pre = new Image();
    pre.decoding = 'async';
    try { pre.fetchPriority = urgent ? 'high' : 'low'; } catch (e) {}
    if (widths.length) {
      if (sizes) pre.sizes = sizes;
      pre.srcset = srcsetFor(url, widths);
    }
    pre.src = url;
    var p = (typeof pre.decode === 'function' ? pre.decode() : new Promise(function (resolve, reject) {
      pre.onload = resolve; pre.onerror = reject;
    })).then(function () { return true; }, function () { return false; });
    warmed[key] = { img: pre, p: p };
    return p;
  }
  var net = navigator.connection || navigator.mozConnection || navigator.webkitConnection || {};
  var frugal = !!net.saveData || /(^|-)(2g|3g)$/.test(net.effectiveType || '');
  var idle = window.requestIdleCallback
    ? function (fn) { window.requestIdleCallback(fn, { timeout: 1500 }); }
    : function (fn) { setTimeout(fn, 250); };
  /* a card that sits in view for a moment gets its other colours fetched quietly */
  var cardWatch = (!frugal && 'IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var c = e.target;
      if (e.isIntersecting) {
        c._dwWarmT = setTimeout(function () {
          cardWatch.unobserve(c);
          idle(function () { if (c._dwWarm) c._dwWarm(); });
        }, 600);
      } else {
        clearTimeout(c._dwWarmT);
      }
    });
  }, { threshold: 0.5 }) : null;

  /* ---------- product card ------------------------------------------------ */
  var openTray = null;

  function initCard(card) {
    if (card.dataset.dwReady) return;
    card.dataset.dwReady = '1';

    var variants = [];
    try { variants = JSON.parse(($('[data-dw-variants]', card) || {}).textContent || '[]'); } catch (e) { variants = []; }

    var img = $('[data-dw-img]', card);
    var altImg = $('[data-dw-alt]', card);
    var swatches = $$('[data-dw-swatch]', card);
    var add = $('[data-dw-add]', card);
    var tray = $('[data-dw-tray]', card);
    var sizes = $$('[data-dw-size]', card);
    var worn = card.dataset.dwWorn || '';
    var hasSizes = sizes.length > 0;
    var addLabel = add ? add.textContent.trim() : '';
    var colour = '';

    /* pick the swatch that matches the featured image; else the first */
    (function () {
      var on = swatches.filter(function (s) { return s.classList.contains('is-on'); });
      if (!swatches.length) return;
      if (on.length !== 1) {
        swatches.forEach(function (s) { s.classList.remove('is-on'); s.setAttribute('aria-pressed', 'false'); });
        on = [swatches[0]];
        on[0].classList.add('is-on'); on[0].setAttribute('aria-pressed', 'true');
      }
      colour = on[0].dataset.c || '';
    })();

    function available(size) {
      return variants.some(function (v) {
        return v.a && (!colour || v.c === colour) && (!hasSizes || v.s === size);
      });
    }
    function findVariant(size) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if ((!colour || v.c === colour) && (!hasSizes || v.s === size)) return v;
      }
      return null;
    }
    function paintSizes() {
      sizes.forEach(function (b) { b.classList.toggle('is-off', !available(b.dataset.dwSize)); });
    }
    var widths = widthsOf(img);
    var sizesAttr = img ? (img.getAttribute('sizes') || '') : '';
    var swapTurn = 0;
    function swapImage(sw) {
      if (!img || !sw.dataset.img) return;
      var url = sw.dataset.img;
      var turn = ++swapTurn;
      if (img.getAttribute('src') === url) { img.classList.remove('is-swapping'); return; }
      /* dim only if the photo is not ready almost at once */
      var slow = setTimeout(function () { if (turn === swapTurn) img.classList.add('is-swapping'); }, 120);
      if (altImg) altImg.removeAttribute('src');
      warm(url, widths, sizesAttr, true).then(function () {
        if (turn !== swapTurn) return;
        clearTimeout(slow);
        if (widths.length) img.srcset = srcsetFor(url, widths);
        else img.removeAttribute('srcset');
        img.src = url;
        if (sw.dataset.alt) img.alt = sw.dataset.alt;
        img.classList.remove('is-swapping');
      });
    }
    function warmCard() {
      if (card._dwWarmed) return;
      card._dwWarmed = true;
      swatches.forEach(function (s) { if (s.dataset.img) warm(s.dataset.img, widths, sizesAttr, false); });
    }
    if (img && swatches.length > 1) {
      card._dwWarm = warmCard;
      card.addEventListener('pointerenter', warmCard, { passive: true, once: true });
      var strip = $('.dw-swatches', card);
      if (strip) {
        strip.addEventListener('touchstart', warmCard, { passive: true, once: true });
        strip.addEventListener('focusin', warmCard, { once: true });
      }
      if (cardWatch) cardWatch.observe(card);
    }
    function hoverSrc() {
      var on = swatches.filter(function (s) { return s.classList.contains('is-on'); })[0];
      return (on && on.dataset.back) || worn || '';
    }

    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        swatches.forEach(function (s) { s.classList.remove('is-on'); s.setAttribute('aria-pressed', 'false'); });
        sw.classList.add('is-on'); sw.setAttribute('aria-pressed', 'true');
        colour = sw.dataset.c || '';
        swapImage(sw);
        paintSizes();
      });
    });

    /* lazy hover image (desktop only, only when a back/as-worn shot exists) */
    var media = $('.dw-card__media', card);
    if (media && altImg && window.matchMedia('(hover: hover)').matches) {
      media.addEventListener('mouseenter', function () {
        var s = hoverSrc();
        if (s && altImg.getAttribute('src') !== s) altImg.src = s;
      });
    }

    function setAdded() {
      if (!add) return;
      add.classList.add('is-added');
      add.textContent = 'Added';
      setTimeout(function () {
        add.classList.remove('is-added');
        add.textContent = addLabel;
      }, 1800);
    }
    function closeTray() {
      if (!tray) return;
      tray.hidden = true;
      if (add) add.setAttribute('aria-expanded', 'false');
      if (add && !add.classList.contains('is-added')) add.textContent = addLabel;
      if (openTray === tray) openTray = null;
    }
    function doAdd(v, btn) {
      if (!v) { toast('That combination is not available right now.'); return; }
      if (!v.a) { toast('Sold out in ' + (v.c ? nice(v.c) : 'this option') + (v.s ? ', size ' + v.s : '') + '.'); return; }
      var busyEl = btn || add;
      if (busyEl) busyEl.classList.add('is-busy');
      if (add) add.disabled = true;
      addVariant(v.id).then(function (json) {
        closeTray();
        setAdded();
        var bits = [card.dataset.dwTitle, nice(v.c), v.s ? 'size ' + v.s : ''].filter(Boolean).join(', ');
        var rack = card.closest('[data-dw-rack]');
        var afterAdd = (rack && rack.dataset.dwAfterAdd) || DW.afterAdd;
        var drawer = $('cart-drawer');
        if (afterAdd === 'drawer' && drawer && typeof drawer.renderContents === 'function') {
          try { drawer.renderContents(json); } catch (e) { syncTheme(json); }
        } else {
          syncTheme(json);
          toast('Added ' + bits, 'View bag', DW.cartUrl);
        }
        document.dispatchEvent(new CustomEvent('smt:cart:updated', { detail: { source: 'dw-card', variantId: v.id } }));
      }).catch(function (err) {
        toast(err && err.message ? err.message : 'Could not add to bag. Try again.');
      }).then(function () {
        if (busyEl) busyEl.classList.remove('is-busy');
        if (add) add.disabled = false;
      });
    }

    if (add) {
      add.addEventListener('click', function () {
        if (add.disabled) return;
        if (!hasSizes) { doAdd(findVariant(''), add); return; }
        var opening = tray.hidden;
        if (openTray && openTray !== tray) {
          var otherCard = openTray.closest('[data-dw-card]');
          openTray.hidden = true;
          if (otherCard) {
            var otherAdd = $('[data-dw-add]', otherCard);
            if (otherAdd) { otherAdd.setAttribute('aria-expanded', 'false'); otherAdd.textContent = otherAdd.dataset.dwLabel || 'Add to bag'; }
          }
        }
        add.dataset.dwLabel = addLabel;
        tray.hidden = !opening;
        add.setAttribute('aria-expanded', opening ? 'true' : 'false');
        add.textContent = opening ? 'Pick a size' : addLabel;
        openTray = opening ? tray : null;
        if (opening) {
          paintSizes();
          var first = sizes.filter(function (b) { return !b.classList.contains('is-off'); })[0];
          if (first) first.focus({ preventScroll: true });
        }
      });
    }
    sizes.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.classList.contains('is-off')) return;
        doAdd(findVariant(b.dataset.dwSize), b);
      });
    });
    paintSizes();
  }

  /* ---------- pack ladder ------------------------------------------------- */
  function initLadder(el) {
    if (el.dataset.dwReady) return;
    el.dataset.dwReady = '1';

    var ids = {};
    var tiers = [];
    try { JSON.parse(el.dataset.dripIds || '[]').forEach(function (id) { ids[id] = true; }); } catch (e) {}
    try { tiers = JSON.parse(el.dataset.tiers || '[]'); } catch (e) { tiers = []; }
    tiers = tiers.filter(function (t) { return t && t.q > 0; }).sort(function (a, b) { return a.q - b.q; });

    var ship = Number(el.dataset.shipThreshold || 0);
    var fmt = el.dataset.moneyFormat || '${{amount}}';
    var fill = $('[data-dw-fill]', el);
    var msg = $('[data-dw-msg]', el);
    var subEl = $('[data-dw-sub]', el);
    var ticks = $$('[data-dw-tick]', el);
    var close = $('[data-dw-ladder-close]', el);
    var maxQ = tiers.length ? tiers[tiers.length - 1].q : 0;
    var inView = false, hasDrip = false, dismissed = false;
    try { dismissed = sessionStorage.getItem('smtdw-ladder') === 'off'; } catch (e) {}

    ticks.forEach(function (t) {
      var q = Number(t.dataset.dwTick || 0);
      if (maxQ && q > 0) t.style.left = Math.min(100, (q / maxQ) * 100) + '%';
      else t.style.display = 'none';
    });

    function noun(t, n) { return t.scope === 'order' ? (n === 1 ? 'item' : 'items') : (n === 1 ? 'Drip piece' : 'Drip pieces'); }
    function cap(s) { s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1); }

    function render(cart) {
      var drip = 0, all = 0;
      (cart.items || []).forEach(function (it) {
        all += it.quantity;
        if (ids[it.product_id]) drip += it.quantity;
      });
      hasDrip = drip > 0;
      var countFor = function (t) { return t.scope === 'order' ? all : drip; };
      var unlocked = null, next = null;
      tiers.forEach(function (t) {
        if (countFor(t) >= t.q) unlocked = t;
        else if (!next) next = t;
      });
      /* progress along the ladder */
      var f = 0;
      if (maxQ) {
        f = next ? Math.min(countFor(next), next.q) / maxQ : 1;
        tiers.forEach(function (t) { if (countFor(t) >= t.q) f = Math.max(f, t.q / maxQ); });
      }
      if (fill) fill.style.setProperty('--fill', String(f));
      ticks.forEach(function (tick) {
        var q = Number(tick.dataset.dwTick || 0);
        var tier = tiers.filter(function (t) { return t.q === q; })[0];
        tick.classList.toggle('is-hit', !!(tier && countFor(tier) >= tier.q));
      });
      /* message: one main line (the next step), one muted line (what is already on) */
      var sub = [];
      if (msg && tiers.length) {
        var html = '';
        if (next) {
          var have = countFor(next);
          var need = next.q - have;
          html = 'Add ' + need + (have ? ' more ' : ' ') + noun(next, need) + ' for <strong>' + esc(next.label) + '</strong>.';
          if (unlocked) sub.push('Unlocked: ' + unlocked.label);
        } else if (unlocked) {
          html = '<strong>' + esc(cap(unlocked.label)) + '</strong> unlocked. Every pack discount is on.';
        }
        msg.innerHTML = html;
      }
      if (ship > 0) {
        var left = ship - (cart.total_price || 0);
        sub.push(left > 0 ? money(left, fmt) + ' to free U.S. shipping' : 'Free U.S. shipping is on');
      }
      if (subEl) {
        subEl.textContent = sub.join(' · ');
        subEl.hidden = sub.length === 0;
      }
      paint();
    }
    function paint() {
      el.classList.toggle('is-open', !dismissed && (inView || hasDrip));
    }
    function refresh() {
      getCart().then(render).catch(function () {});
    }

    if (close) close.addEventListener('click', function () {
      dismissed = true;
      try { sessionStorage.setItem('smtdw-ladder', 'off'); } catch (e) {}
      paint();
    });

    var rack = el.closest('[data-dw-rack]');
    if (rack && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries.some(function (e) { return e.isIntersecting; });
        paint();
      }, { rootMargin: '-15% 0px -15% 0px', threshold: 0 }).observe(rack);
    } else {
      inView = true;
    }

    document.addEventListener('smt:cart:updated', refresh);
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
    if (typeof window.subscribe === 'function') {
      try { window.subscribe('cart-update', refresh); } catch (e) {}
    }
    refresh();
  }


  /* ---------- category chips ------------------------------------------- */
  function initChips(rack) {
    if (rack.dataset.dwChipsReady) return;
    rack.dataset.dwChipsReady = '1';
    var chips = $$('[data-dw-chip]', rack);
    if (!chips.length) return;
    function apply(cat) {
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c.dataset.dwChip === cat ? 'true' : 'false'); });
      var groups = $$('[data-dw-group]', rack);
      var counts = groups.map(function (group) {
        var shown = 0;
        $$('[data-dw-card]', group).forEach(function (card) {
          var on = cat === 'all' || card.dataset.dwCat === cat;
          card.hidden = !on;
          if (on) shown++;
        });
        return shown;
      });
      var total = counts.reduce(function (a, b) { return a + b; }, 0);
      groups.forEach(function (group, i) {
        var empty = $('[data-dw-empty]', group);
        /* the first group owns the empty message: show it only when nothing matches anywhere */
        if (i === 0 && empty) {
          group.hidden = false;
          empty.hidden = total !== 0;
          var grid = $('.dw-grid', group);
          if (grid) grid.hidden = counts[i] === 0;
        } else {
          group.hidden = counts[i] === 0;
        }
      });
      rack.classList.toggle('dw-rack--main-empty', counts[0] === 0 && total > 0);
      var live = $('[data-dw-chip-live]', rack);
      if (live) live.textContent = cat === 'all' ? '' : (total ? 'Showing ' + total + ' ' + cat.toLowerCase() : 'Nothing in ' + cat.toLowerCase());
    }
    chips.forEach(function (c) { c.addEventListener('click', function () { apply(c.dataset.dwChip); }); });
  }

  /* ---------- boot -------------------------------------------------------- */
  function boot(root) {
    $$('[data-dw-rack]', root).forEach(function (rack) {
      DW.afterAdd = rack.dataset.dwAfterAdd || 'stay';
      DW.cartUrl = rack.dataset.dwCartUrl || (routes.cart_url || '/cart');
    });
    $$('[data-dw-card]', root).forEach(initCard);
    $$('[data-dw-rack]', root).forEach(initChips);
    $$('[data-dw-ladder]', root).forEach(initLadder);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  DW.boot = boot;
  DW.money = money;
  DW.toast = toast;
  DW.esc = esc;
  DW.getCart = getCart;
  DW.addVariant = addVariant;
  DW.syncTheme = syncTheme;
  DW.sections = sectionsToRefresh;
})();
